import { render, staticRenderFns } from "./MultipleTest.vue?vue&type=template&id=6d50ee94&"
import script from "./MultipleTest.vue?vue&type=script&lang=js&"
export * from "./MultipleTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports